(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  DNB.SectionReveal = {
    init: function () {
      var DNBRef = window.DNB;
      if (!window.gsap || !window.ScrollTrigger || DNBRef.prefersReducedMotion()) return;

      DNBRef.onScrollReady(function () {
        gsap.registerPlugin(ScrollTrigger);

          var sections = document.querySelectorAll("main > section:not(.home-hero):not(.blog)");
        sections.forEach(function (section) {
          var items = Array.prototype.filter.call(
            section.querySelectorAll(
              "article, [class*='__item'], [class*='__card'], [class*='__tile'], [class*='__slide']"
            ),
            function (el) {
              // Swiper alanlarını hariç tut: GSAP clearProps, Swiper'ın slaytlara
              // yazdığı inline width/margin değerlerini silip yapışmaya yol açıyor.
              return !el.classList.contains("swiper-slide") && !el.closest(".swiper");
            }
          );

          gsap.set(section, { autoAlpha: 0, y: 24 });

          gsap.to(section, {
            autoAlpha: 1,
            y: 0,
            duration: 0.68,
            ease: "power2.out",
            scrollTrigger: {
              trigger: section,
              start: "top 75%",
              once: true,
              invalidateOnRefresh: true
            },
            onComplete: function () {
              gsap.set(section, { clearProps: "all" });
            }
          });

          if (items.length) {
            gsap.from(items, {
              autoAlpha: 0,
              y: 24,
              duration: 0.34,
              ease: "sine.out",
              stagger: 0.08,
              scrollTrigger: {
                trigger: section,
                start: "top 75%",
                once: true,
                invalidateOnRefresh: true
              },
              onComplete: function () {
                gsap.set(items, { clearProps: "all" });
              }
            });
          }
        });
      });
    }
  };
})(window, document);
